export default "__VITE_ASSET__CJ4wB2Nd__"